import React, { useState, useMemo, useRef } from 'react';
import { useLocale } from 'context/LanguageContext';
import useWindowClick from 'hooks/useWindowClick';
import LOCALES from "constants/locales";
import LANGUAGES_PARAMS from "extra/languages";

import "./language-switcher.scss";

const ALL_LANGUAGES = LOCALES.map( l => ({ value: l, ...LANGUAGES_PARAMS[ l ]}));

export default function LanguageSwitcher( props ) { 

	const main_el = useRef();

	const [ locale, changeLocale ] = useLocale();
	const [ open, setOpen ] = useState( false );

	const active_language = useMemo(() => ALL_LANGUAGES.find( item => item.value === locale ), [ locale ]);

	const ls_extra_classes = useMemo(() => {
		return open ? [ props.extra_classes || "", "open"] : [ props.extra_classes ];
	}, [ open ]);


	useWindowClick( e => {
		!main_el.current.contains( e.target ) && setOpen( false );
	}, []);

	return (
		<div ref={ main_el } className={`language-switcher ${ ls_extra_classes.join(" ") }`} translate="no">

			<div className="language-switcher__active df-ac" onClick={ () => setOpen( !open )}> 

				<div>
					{ active_language && 
						<div className="df-ac with-icon"> 
							{ active_language.svg }  
							<span> { active_language.label } </span>  
						</div>
					}
				</div>			
			</div>

			<div className="language-switcher__languages">
				{ ALL_LANGUAGES && !!ALL_LANGUAGES.length && 
					ALL_LANGUAGES.map( lang => (
						<div 
							key={ lang.value } 
							className="df-ac with-icon" 
							onClick={() => { 
								changeLocale( lang.value )
								setOpen( false );
						}}> 
							{ lang.svg }
							<span> { lang.label } </span>  
						</div>
					)
				)}
			</div>
		</div>
	)
}